var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exlamation filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6665 16.725C12.8998 16.725 13.0915 16.65 13.2415 16.5C13.3915 16.35 13.4665 16.1583 13.4665 15.925C13.4665 15.6917 13.3915 15.5 13.2415 15.35C13.0915 15.2 12.8998 15.125 12.6665 15.125C12.4332 15.125 12.2415 15.2 12.0915 15.35C11.9415 15.5 11.8665 15.6917 11.8665 15.925C11.8665 16.1583 11.9415 16.35 12.0915 16.5C12.2415 16.65 12.4332 16.725 12.6665 16.725ZM11.9165 13.075H13.4165V7.075H11.9165V13.075ZM12.6665 21.5C11.3498 21.5 10.1125 21.25 8.9545 20.75C7.79584 20.25 6.7915 19.575 5.9415 18.725C5.0915 17.875 4.4165 16.8707 3.9165 15.712C3.4165 14.554 3.1665 13.3167 3.1665 12C3.1665 10.6833 3.4165 9.44567 3.9165 8.287C4.4165 7.129 5.0915 6.125 5.9415 5.275C6.7915 4.425 7.79584 3.75 8.9545 3.25C10.1125 2.75 11.3498 2.5 12.6665 2.5C13.9832 2.5 15.2208 2.75 16.3795 3.25C17.5375 3.75 18.5415 4.425 19.3915 5.275C20.2415 6.125 20.9165 7.129 21.4165 8.287C21.9165 9.44567 22.1665 10.6833 22.1665 12C22.1665 13.3167 21.9165 14.554 21.4165 15.712C20.9165 16.8707 20.2415 17.875 19.3915 18.725C18.5415 19.575 17.5375 20.25 16.3795 20.75C15.2208 21.25 13.9832 21.5 12.6665 21.5Z",
    fill: "#F59E0B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircleIcon);
export default __webpack_public_path__ + "static/media/warning-circle-icon.5e0796088fd91bf1ca71b1991e9c418d.svg";
export { ForwardRef as ReactComponent };